import type { NamedPathLookupAdvancedOptions } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface DeleteAdvancedOptionsCommand {
  advancedOptions: NamedPathLookupAdvancedOptions;
}

export const deleteAdvancedOptions: GraphCommandFactory<
  DeleteAdvancedOptionsCommand
> = (cmdContext) => async (command) => {
  try {
    await cmdContext.api.request({
      url: `/graphs/path-lookup/advanced-options/${command.advancedOptions.id}`,
      method: 'DELETE',
    });

    cmdContext.updateState((draft) => {
      draft.pathlookup.advancedOptions =
        draft.pathlookup.advancedOptions.filter(
          (a) => a.id !== command.advancedOptions.id,
        );
      // Fixed noUncheckedIndexedAccess NIM-19408
      draft.pathlookup.selectedAdvancedOptions =
        draft.pathlookup.advancedOptions[0]!;
    });

    cmdContext.showNotification({
      type: 'success',
      message:
        cmdContext.msg.canvasGraph.graphSidePanel.pathlookup.advancedOptions
          .deleted,
    });
  } catch (e) {
    cmdContext.updateState((draft) => {
      draft.loading = 'ERROR';
    });
    cmdContext.logError(e, 'GRAPH');
  }
};
